import {QueryRouteQueryType} from '@github-ui/react-core/future/data-router-types'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import {reactFetchJSON} from '@github-ui/verified-fetch'
import {copilotAgentsAppBuilder} from '../config/app-builder'
import type {CopilotAgentsTaskPayload} from '../types/copilot-agents-task-payload'

const CLI_REMOTE_SESSION_NOTICE_KEY = 'copilot_cli_remote_session_info'

interface NoticeDismissalResult {
  dismissed: boolean
}

async function fetchNoticeDismissal(): Promise<NoticeDismissalResult> {
  const resp = await reactFetchJSON(`/settings/notice-dismissals/${CLI_REMOTE_SESSION_NOTICE_KEY}`)
  if (!resp.ok) {
    throw new Error(`Failed to check notice dismissal: ${resp.status}`)
  }

  return (await resp.json()) as NoticeDismissalResult
}

const noticeDismissalRouteQuery = {
  queryName: 'noticeDismissal',
  queryFn: async (): Promise<NoticeDismissalResult> => fetchNoticeDismissal(),
  type: QueryRouteQueryType.Deferred,
} as const

// Global task detail route, rendered inside the copilot-agents app.
export const copilotAgentsTaskRoute = copilotAgentsAppBuilder.createQueryRouteConfig('copilotAgentsTaskRoute', {
  path: '/copilot/tasks/:taskId',
  queries: [mainQuery<CopilotAgentsTaskPayload>(), noticeDismissalRouteQuery],
})
